import React from 'react';
import { ResultType } from '@src/js/constants.js';
import SlotGrid from './SlotGrid.jsx';
import { ContentUtils } from '@js/utils/utils-imports.es6.js';

const ProviderSecondaryLocations = ({
                                      availabilityByDays,
                                      name,
                                      address,
                                      id = null,
                                      npi,
                                      providerEpicId,
                                      viewFewerTimesText,
                                      viewMoreTimesText,
                                      distanceAwayText,
                                      triggerRedraw,
                                      triggerRedrawByIncrementing,
                                      nextAvailableText
                                    }) => {
  return (
    <>
      <div className='other-locations__location'>
        <h4 className='location__name'>{ContentUtils.decodeHtml(name)}</h4>
        <p className='location__address'>{ContentUtils.decodeHtml(address)}</p>
        <span className='location__distance'>{distanceAwayText}</span>
      </div>
      {
        providerEpicId &&
        <div
          className='other-locations__scheduling-info scheduling-info'
          data-deptid={id}
          data-npi={npi}
          data-resulttype={ResultType.PROVIDERS}
          data-providerid={providerEpicId}
        >
          <SlotGrid
            key={`${npi}-${id}`}
            availabilityByDays={availabilityByDays}
            viewMoreTimesText={viewMoreTimesText}
            viewFewerTimesText={viewFewerTimesText}
            triggerRedraw={triggerRedraw}
            triggerRedrawByIncrementing={triggerRedrawByIncrementing}
            nextAvailableText={nextAvailableText}
          />
        </div>
      }
    </>
  )
}

export default ProviderSecondaryLocations;
